import ContactCard from "../../features/Contact/ContactCard/ContactCard";
import './Contact.css';
import MainLayout from "../../layouts/MainLayout/MainLayout";
import {useLocation} from "react-router";
import { useAppContext } from "../../context/AppState/AppContext";

const Contact = () => {
    const {jsonTexts} = useAppContext();
    const {subject, message, data, contactTitle, formTitle, form} = jsonTexts.contact;
    const { state: courseData } = useLocation();

    return (
        <MainLayout overflow="hidden">
            <section className="contact-section">
                <ContactCard formData={form} contactTitle={contactTitle} formTitle={formTitle} subject={subject} message={message} data={data} courseData={courseData}/>
            </section>
        </MainLayout>
    )
}
export default Contact